import { render } from "./OrdersAdd.vue?vue&type=template&id=25bb3139"
import script from "./OrdersAdd.vue?vue&type=script&lang=js"
export * from "./OrdersAdd.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__